import { createFileRoute } from '@tanstack/react-router'
import TimeSeriesSubEntityTab from '@admin/preferences/entities/TimeSeriesSubEntityTab'

export const Route = createFileRoute(
  '/_auth/preferences/entityTypes/$entityTypeId/timeSeriesSubEntity',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { entityType } = Route.useRouteContext()

  return <TimeSeriesSubEntityTab entityType={entityType} />
}
